var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoutingStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_541_1838",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_541_1838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0443 30.6444C14.0221 30.6444 12.1203 30.2573 10.3388 29.4833C8.55731 28.7092 7.00176 27.6573 5.67214 26.3277C4.34249 24.9981 3.29064 23.4425 2.51657 21.661C1.7425 19.8796 1.35547 17.9777 1.35547 15.9555C1.35547 13.9407 1.7425 12.0444 2.51657 10.2666C3.29064 8.48882 4.34249 6.93512 5.67214 5.6055C7.00176 4.27586 8.55731 3.2277 10.3388 2.46104C12.1203 1.69437 14.0221 1.31104 16.0443 1.31104C18.0592 1.31104 19.9555 1.69437 21.7332 2.46104C23.511 3.2277 25.0647 4.27586 26.3943 5.6055C27.724 6.93512 28.7721 8.48882 29.5388 10.2666C30.3055 12.0444 30.6888 13.9407 30.6888 15.9555C30.6888 17.9777 30.3055 19.8796 29.5388 21.661C28.7721 23.4425 27.724 24.9981 26.3943 26.3277C25.0647 27.6573 23.511 28.7092 21.7332 29.4833C19.9555 30.2573 18.0592 30.6444 16.0443 30.6444ZM15.0999 25.811C15.3369 26.0481 15.6184 26.1666 15.9443 26.1666C16.2703 26.1666 16.5518 26.0481 16.7888 25.811L25.8999 16.8333C26.1369 16.5814 26.2554 16.2851 26.2554 15.9444C26.2554 15.6036 26.1369 15.3147 25.8999 15.0777L16.7888 6.09994C16.5518 5.86291 16.2703 5.7444 15.9443 5.7444C15.6184 5.7444 15.3369 5.86291 15.0999 6.09994L6.12214 15.0777C5.88509 15.3147 5.76657 15.6073 5.76657 15.9555C5.76657 16.3036 5.88509 16.5962 6.12214 16.8333L15.0999 25.811ZM10.6999 19.7666V14.6333C10.6999 14.337 10.8221 14.0666 11.0666 13.8222C11.311 13.5777 11.5814 13.4555 11.8777 13.4555H18.3666L16.5888 11.6555L18.1666 10.0999L22.5888 14.5222L18.0555 19.0999L16.4777 17.5444L18.3221 15.6777H12.9221V19.7666H10.6999ZM16.0443 28.4222C19.5036 28.4222 22.4388 27.2129 24.8499 24.7944C27.261 22.3759 28.4666 19.4296 28.4666 15.9555C28.4666 12.4962 27.261 9.56105 24.8499 7.14994C22.4388 4.73882 19.5036 3.53327 16.0443 3.53327C12.5703 3.53327 9.62397 4.73882 7.20544 7.14994C4.78692 9.56105 3.57767 12.4962 3.57767 15.9555C3.57767 19.4296 4.78692 22.3759 7.20544 24.7944C9.62397 27.2129 12.5703 28.4222 16.0443 28.4222Z",
    fill: "#F1F1F1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoutingStart);
export default __webpack_public_path__ + "static/media/routing_start.4f4df11d0b66526edc62dcba44cb55e9.svg";
export { ForwardRef as ReactComponent };